var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class WordPressAjaxService {
    constructor(ajaxUrl, defaultNonce = null) {
        this.ajaxUrl = ajaxUrl;
        this.defaultNonce = defaultNonce;
    }
    sendRequest(action, data, security = this.defaultNonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('action', action);
            if (security) {
                formData.append('security', security);
            }
            for (const [key, value] of Object.entries(data)) {
                formData.append(key, String(value));
            }
            const response = yield fetch(this.ajaxUrl, {
                method: 'POST',
                body: formData,
            });
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            return response.json();
        });
    }
}
